module.exports = __webpack_public_path__ + "img/first-responder.057f6610.png";